import MailIcon from '@/icons/mail.svg';
import PhoneIcon from '@/icons/phone.svg';
import { TeamMemberSnippet } from '@/types';
import Image from '@components/Image';
import { phoneForLinks } from '@utils/phone';
import clsx from 'clsx';
import Link from 'next/link';

type Props = {
  person: TeamMemberSnippet;
  context: 'about-us' | 'contact';
};

function TeamMember(props: Props) {
  const { person, context } = props;

  return (
    <div
      className={clsx('team-member', {
        'team-member--about-us': context === 'about-us',
        'team-member--contact': context === 'contact',
      })}
    >
      <div className='team-member__content'>
        {person.picture ? (
          <div className='team-member__image-container'>
            <Image className='team-member__image' image={person.picture} height={200} width={360} />
          </div>
        ) : null}
        <div className='team-member__info'>
          <div className='team-member__name'>{person.name}</div>
          {person.role ? <div className='team-member__role'>{person.role}</div> : null}
          {person.mail ? (
            <Link href={`mailto:${person.mail}`} className='team-member__mail'>
              <MailIcon />
              {person.mail}
            </Link>
          ) : null}
          {person.phone ? (
            <Link href={`tel:${phoneForLinks(person.phone)}`} className='team-member__phone'>
              <PhoneIcon />
              {person.phone}
            </Link>
          ) : null}

          {person.booking_link && context === 'contact' ? (
            <Link
              href={person.booking_link}
              target='_blank'
              className='team-member__booking-link button button--primary'
            >
              Jetzt Beratung buchen!
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default TeamMember;
